var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":_vm.width,"height":_vm.width}},[_c('circle',{attrs:{"cx":_vm.cx,"cy":_vm.cy,"r":_vm.r}}),_vm._v(" "),_c('text',{attrs:{"x":"50%","y":"50%","text-anchor":"middle","dx":"-0.02em","dy":".35em"},domProps:{"textContent":_vm._s(_vm.text)}}),_vm._v("\n  Sorry, your browser does not support inline SVG.\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-339a3134","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NumberBadge.vue
// module id = null
// module chunks = 